export default {
  LEGISLATOR_DISTANCES: 'legislator_distances',
  STATE_LEGISLATOR_DISTANCES: 'state_legislator_distances',
};
